import { HttpInterceptorFn } from '@angular/common/http';
import * as CryptoJS from 'crypto-js';
import { inject } from '@angular/core';
import { JWTTokenServiceService } from 'src/app/public/services/token.service';
import { map, catchError, throwError } from 'rxjs';
import { HttpResponse, HttpErrorResponse } from '@angular/common/http';

const SECRET_KEY = '12345678dsadsadas90abcdef1234567';

export const EncryptionInterceptor: HttpInterceptorFn = (req, next) => {
  const tokenService = inject(JWTTokenServiceService);

  const encrypt = (data: any): string => {
    return CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
  };

  const decrypt = (ciphertext: string): any => {
    const bytes = CryptoJS.AES.decrypt(ciphertext, SECRET_KEY);
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  };

  let token = tokenService.getToken();
  if (!token) {
    token = localStorage.getItem('getpublicToken') || '';
  }

  let modifiedReq = req;
  if (!(req.body instanceof FormData)) {
    const encryptedBody = encrypt(req.body || {});
    modifiedReq = req.clone({
      body: { payload: encryptedBody },
      headers: req.headers.set('Authorization', `Bearer ${token}`)
    });
  } else {
    modifiedReq = req.clone({
      headers: req.headers.set('Authorization', `Bearer ${token}`)
    });
  }

  function parseDecryptedApiBody(decrypted: any, _requestUrl: string): any {
  if (typeof decrypted === 'string') {
    try {
      return JSON.parse(decrypted);
    } catch {
      return decrypted;
    }
  }
  return decrypted;
}
  return next(modifiedReq).pipe(
    map(event => {
      if (event instanceof HttpResponse && event.body && typeof event.body === 'object' && 'response' in event.body) {
        const responseBody = event.body as { response: string };
        const decrypted = decrypt(responseBody.response);
        return event.clone({ body: parseDecryptedApiBody(decrypted, req.url) });
      }
      return event;
    }),
    catchError((error: HttpErrorResponse) => throwError(() => error))
  );
};

// Export with the name expected by app.config.ts
export const HttpResponseInterceptor = EncryptionInterceptor;
